import type { LocalizedSettingValue } from './localized-setting-value';

/**
 * The allow-listed settings `GET /api/v1/public/settings` serves anonymously. Mirrors
 * `PublicSettingsDTO`.
 *
 * Both halves are deliberately open maps: the server owns which keys are public, and a key added
 * there must not need a client release to appear.
 *
 * They are two maps rather than one because a value with a language and a value without one are
 * read differently. Flattening them would mean the server choosing a language for the caller —
 * which is the silent fallback the split exists to prevent.
 */
export interface PublicSettings {
    /** Values that read the same in every language: numbers, flags, links, codes. */
    values: Record<string, string>;
    /** Prose, in both languages. A key is present only when both are filled. */
    localized: Record<string, LocalizedSettingValue>;
}

export const EMPTY_PUBLIC_SETTINGS: PublicSettings = { values: {}, localized: {} };
